import axios from "./axios";
import { API_ERROR_CODE } from "./utils/dataCenter";

const prefix = "/v1/inventory";

export function getLatestInventoryByPlantAndItem( // 재고량 분석
  COMPANY_ID: string,
  SHOP_ID: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID
      });
      const response = await axios.get(
        `${prefix}/getLatestInventoryByPlantAndItem?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getLatestInventoryByPlantAndItem error: `, e);
      reject(e);
    }
  });
}

export function modifyUpdateQty(SHOP_ID: string, items: any[]) {
  // console.log("modifyUpdateQty", {
  //   SHOP_ID,
  //   items,
  // });

  return new Promise(async (resolve, reject) => {
    try {
      items.map((item:any)=>{
        item.SHOP_ID = SHOP_ID;
      });
      
      const response = await axios.post(`${prefix}/modifyUpdateQty`, {
        SHOP_ID,
        items,
      });
      
      console.log(`${prefix}modifyUpdateQty response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}modifyUpdateQty error: `, e);
      reject(e);
    }
  });
}
